// Static branded scene: client-approved kit render (box, vial, storefront)
// with the background removed — transparent, so it sits seamlessly on the page.
export const HeroArtwork = () => (
  <div data-testid="hero-artwork" className="relative mx-auto w-full max-w-[480px] select-none sm:max-w-[560px]">
    <div
      aria-hidden="true"
      className="absolute left-1/2 top-1/2 h-72 w-72 -translate-x-1/2 -translate-y-1/2 rounded-full bg-lilac/[0.12] blur-3xl"
    />
    <img
      src="/hero-kit.webp"
      alt="A branded business kit: lilac packaging box, research vial, and storefront website preview"
      width="1254"
      height="1254"
      loading="eager"
      fetchpriority="high"
      decoding="async"
      className="relative w-full"
    />
  </div>
);
